module.exports = __webpack_public_path__ + "static/yale.ec271f25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/yale.png
// module id = 2212
// module chunks = 61762850755587